import script from "./SfxCardNotificationUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxCardNotificationUser.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
